export default __webpack_public_path__ + "static/media/Dialog5.db72bbc5.svg";